// eslint-disable-next-line import/prefer-default-export
export const notificationsGetters = {
    notifications(state) {
        return state.notifications
    }
};
